// Explicit category: tags in PocketBase's existing Keywords field take priority.
// The remaining search terms stay untouched; custom category names are allowed.
const CATEGORIES = [
    { key: 'shoes', label: 'Shoes', scale: 1, match: /\b(shoes?|boots?|mules?|sandals?|heels?|pumps?|sneakers?)\b/i },
    { key: 'bags', label: 'Bags', scale: 0.9, match: /\b(bags?|clutch(?:es)?|totes?|purses?)\b/i },
    { key: 'necklaces', label: 'Necklaces', scale: 0.82, match: /\b(necklaces?|chokers?)\b/i },
    { key: 'belts', label: 'Belts', scale: 0.82, match: /\bbelts?\b/i },
    { key: 'headpieces', label: 'Headpieces', scale: 0.82, match: /\b(headpieces?|crowns?|combs?)\b/i },
    { key: 'bracelets', label: 'Bracelets', scale: 0.64, match: /\b(bracelets?|bangles?|cuffs?)\b/i },
    { key: 'earrings', label: 'Earrings', scale: 0.58, match: /\bearrings?\b/i },
    { key: 'brooches', label: 'Brooches & pins', scale: 0.58, match: /\b(hairpins?|brooch(?:es)?|pins?)\b/i },
    { key: 'rings', label: 'Rings', scale: 0.46, match: /\brings?\b/i },
];

// Visually identified objects whose existing AI search tags omit the type.
// A category: tag can override these too, without changing this file.
const REVIEWED_CATEGORIES = {
    lng619nytthtedi: 'necklaces', // SS14 Accessory 10
    n09gmapbzsg3hbm: 'bags', // SS14 Accessory 38
    cv3i6qz77l17axm: 'necklaces', // RS13 Accessory 2
    q7f1e4bkvm1h1gg: 'headpieces', // FW12 Accessory 6 (hair comb)
};

function tagsFor(item) {
    return (Array.isArray(item.keywords) ? item.keywords : String(item.keywords || '').split(','))
        .map(tag => String(tag).trim()).filter(Boolean);
}

function inferredCategory(item) {
    if (REVIEWED_CATEGORIES[item.id]) return REVIEWED_CATEGORIES[item.id];
    for (const tag of tagsFor(item)) {
        if (/^category\s*:/i.test(tag)) continue;
        const category = CATEGORIES.find(c => c.match.test(tag));
        if (category) return category.key;
    }
    return 'other';
}

export function accessoryCategory(item = {}) {
    const explicit = tagsFor(item).find(tag => /^category\s*:\s*\S/i.test(tag));
    if (explicit) {
        const key = explicit.replace(/^category\s*:\s*/i, '').trim().toLowerCase().replace(/\s+/g, '-');
        // Accept singular names for the standard categories, but keep custom
        // names (e.g. drop-earrings or chokers) as distinct editable subgroups.
        return CATEGORIES.find(c => c.key === key || c.key.replace(/s$/, '') === key
            || (c.key === 'brooches' && key === 'brooch'))?.key || key;
    }
    return inferredCategory(item);
}

export function categoryLabel(key) {
    return CATEGORIES.find(c => c.key === key)?.label
        || (key === 'other' ? 'Other accessories' : key.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()));
}

export function accessoryScale(item = {}) {
    const key = accessoryCategory(item);
    // Custom subgroups inherit their object's usual display weight.
    return (CATEGORIES.find(c => c.key === key) || CATEGORIES.find(c => c.key === inferredCategory(item)))?.scale ?? 0.78;
}
